/**
 * Display helpers for {@code act_billing_role.role_description} and {@code role_name}.
 * Labels must come from the database only — no hardcoded role-code aliases.
 */

/** @param {string | null | undefined} roleDescription */
/** @param {string | null | undefined} roleName */
export function rolePrimaryLabel(roleDescription, roleName) {
  const description = String(roleDescription ?? "").trim();
  if (description) {
    return description;
  }
  return String(roleName ?? "").trim();
}
